export const DELIVERY_DRAWER_URL_FRAGMENT_ID = 'delivery-and-returns-info';
export const REVIEWS_DRAWER_URL_FRAGMENT_ID = 'reviews-drawer';
export const REVIEWS_URL_FRAGMENT_ID = 'reviews';

/**
 * `string | number` because rar-data-api ids are numeric and Feefo's are opaque strings
 * that `Number()` would corrupt.
 */
export const getReviewsDrawerURLFragment = (reviewId?: number | string | null) => {
  return `${REVIEWS_DRAWER_URL_FRAGMENT_ID}${reviewId ? `-${reviewId}` : ''}`;
};

/** The drawer's href, for the list or for one review in full. */
export const getReviewsDrawerHref = (reviewId?: number | string | null) =>
  `#${getReviewsDrawerURLFragment(reviewId)}`;
